import { NavLink } from "react-router-dom";
import logo from "../../assets/images/logo/hv1.svg";
import { useState, useEffect } from "react";

export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.matchMedia('(max-width: 1024px)').matches);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (isMobile && isMenuOpen) {
      console.log('Mobile menu is open!');
    }
  }, [isMobile, isMenuOpen]);

  const handleMenuToggle = () => setIsMenuOpen((open) => !open);
  const handleLinkClick = () => setIsMenuOpen(false);

  return (
    <header className="navbar-modern shadow-lg bg-primary text-white font-futura sticky top-0 z-50 w-full" style={{maxWidth: '100vw', paddingLeft: 0, paddingRight: 0, minHeight: '80px'}}>
      <div className="flex items-center w-full" style={{minHeight: '80px'}}>
        {/* Logo - flush left */}
        <NavLink to="/" className="flex items-center pl-4 pr-4 md:pr-8 h-full" onClick={handleLinkClick} style={{height: '100%'}}>
          <img src={logo} alt="logo" className="h-10 w-auto" />
        </NavLink>
        {/* Hamburger (mobile) - only show on small screens */}
        {isMobile && !isMenuOpen && (
          <button
            className="md:hidden flex items-center justify-center p-2 rounded transition hover:bg-accent focus:outline-none mr-2 ml-auto"
            aria-label="Expand menu"
            onClick={handleMenuToggle}
          >
            <svg
              className="h-7 w-7 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8h16M4 16h16" />
            </svg>
          </button>
        )}
        {/* Nav Links - only show on large screens */}
        {!isMobile && (
          <nav className="nav-links-modern md:flex md:items-center md:space-x-6 font-bold text-base transition-all duration-300 ml-auto">
            <NavLink
              to="/"
              className={({ isActive }) =>
                `px-4 py-2 rounded-lg transition-colors duration-200 hover:bg-accent hover:text-primary ${isActive ? "underline text-accent bg-transparent" : ""}`
              }
              onClick={handleLinkClick}
              end
            >
              Home
            </NavLink>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                `px-4 py-2 rounded-lg transition-colors duration-200 hover:bg-accent hover:text-primary ${isActive ? "underline text-accent bg-transparent" : ""}`
              }
              onClick={handleLinkClick}
            >
              About Us
            </NavLink>
            <NavLink
              to="/how-it-works"
              className={({ isActive }) =>
                `px-4 py-2 rounded-lg transition-colors duration-200 hover:bg-accent hover:text-primary ${isActive ? "underline text-accent bg-transparent" : ""}`
              }
              onClick={handleLinkClick}
            >
              How it works?
            </NavLink>
            <NavLink
              to="/blogs"
              className={({ isActive }) =>
                `px-4 py-2 rounded-lg transition-colors duration-200 hover:bg-accent hover:text-primary ${isActive ? "underline text-accent bg-transparent" : ""}`
              }
              onClick={handleLinkClick}
            >
              Blogs/Insights
            </NavLink>
            <NavLink
              to="/faq"
              className={({ isActive }) =>
                `px-4 py-2 rounded-lg transition-colors duration-200 hover:bg-accent hover:text-primary ${isActive ? "underline text-accent bg-transparent" : ""}`
              }
              onClick={handleLinkClick}
            >
              FAQs
            </NavLink>
            <NavLink
              to="/contact-us"
              className={({ isActive }) =>
                `px-4 py-2 rounded-lg transition-colors duration-200 hover:bg-accent hover:text-primary ${isActive ? "underline text-accent bg-transparent" : ""}`
              }
              onClick={handleLinkClick}
            >
              Contact Us
            </NavLink>
          </nav>
        )}
      </div>
      {/* Mobile Overlay Menu */}
      {isMobile && isMenuOpen && (
        <nav
          style={{
            zIndex: 9999,
            paddingTop: '3.5rem',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: '#145c47',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: '0.3rem',
            fontSize: '1.05rem',
            boxShadow: '0 2px 16px 0 rgba(0,0,0,0.18)',
            borderBottom: '2px solid #156f5b',
            overflowY: 'auto',
          }}
        >
          {/* Close button for mobile menu */}
          <button
            className="absolute top-4 right-4 text-white text-3xl md:hidden z-50"
            aria-label="Close menu"
            onClick={handleMenuToggle}
            style={{background: 'none', border: 'none'}}
          >
            &times;
          </button>
          <NavLink
            to="/"
            className={({ isActive }) =>
              `text-center my-1 py-2 rounded-lg transition-colors duration-200 hover:bg-accent hover:text-primary ${isActive ? "underline text-accent bg-transparent" : ""}`
            }
            onClick={handleLinkClick}
            end
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              `text-center my-1 py-2 rounded-lg transition-colors duration-200 hover:bg-accent hover:text-primary ${isActive ? "underline text-accent bg-transparent" : ""}`
            }
            onClick={handleLinkClick}
          >
            About Us
          </NavLink>
          <NavLink
            to="/how-it-works"
            className={({ isActive }) =>
              `text-center my-1 py-2 rounded-lg transition-colors duration-200 hover:bg-accent hover:text-primary ${isActive ? "underline text-accent bg-transparent" : ""}`
            }
            onClick={handleLinkClick}
          >
            How it works?
          </NavLink>
          <NavLink
            to="/blogs"
            className={({ isActive }) =>
              `text-center my-1 py-2 rounded-lg transition-colors duration-200 hover:bg-accent hover:text-primary ${isActive ? "underline text-accent bg-transparent" : ""}`
            }
            onClick={handleLinkClick}
          >
            Blogs/Insights
          </NavLink>
          <NavLink
            to="/faq"
            className={({ isActive }) =>
              `text-center my-1 py-2 rounded-lg transition-colors duration-200 hover:bg-accent hover:text-primary ${isActive ? "underline text-accent bg-transparent" : ""}`
            }
            onClick={handleLinkClick}
          >
            FAQs
          </NavLink>
          <NavLink
            to="/contact-us"
            className={({ isActive }) =>
              `text-center my-1 py-2 rounded-lg transition-colors duration-200 hover:bg-accent hover:text-primary ${isActive ? "underline text-accent bg-transparent" : ""}`
            }
            onClick={handleLinkClick}
          >
            Contact Us
          </NavLink>
        </nav>
      )}
    </header>
  );
};
